const calcSelections = (selections, values, name, remove) => {
  const currentOption = selections.length > 0 ? selections[selections.length - 1] : null;
  const currentArray = values[name];
  const otherArray = values[name === 'workingLocations' ? 'additionalWorkingLocations' : 'workingLocations'];
  const doesMatch =
    currentOption && otherArray ? Boolean(otherArray.find((opt) => opt.value === currentOption.value)) : false;

  if (selections.length === 0) {
    if (Array.isArray(currentArray)) {
      currentArray.forEach(() => remove(0));
    } else {
      remove(0);
    }

    return;
  }

  // eslint-disable-next-line consistent-return
  return {
    currentOption,
    currentArray,
    otherArray,
    doesMatch,
  };
};

export { calcSelections };
